import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
	getScrollHeight,
	getOffsetHeight,
} from '@sparefoot/react-core/utils/dom';

import './Expand.scss';

// Expand / Collapse Animation Component
export default class Expand extends PureComponent {
	constructor(props) {
		super(props);

		this.bindRef = this.bindRef.bind(this);
		this.enter = this.enter.bind(this);
		this.exit = this.exit.bind(this);

		this.instance = null;
		this.teaserHeight = null;
		this.animationDuration = 250;

		this.state = {
			expanded: !!this.props.showing,
			height: this.props.showing ? null : 0,
			overflow: 'hidden',
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (!this.props.showing && nextProps.showing) {
			this.enter();
		} else if (this.props.showing && !nextProps.showing) {
			this.exit();
		}
	}

	enter() {
		// initial
		this.setState(
			{
				expanded: true,
				height: this.teaserHeight || 0,
				overflow: 'hidden',
			},
			() => {
				// animate
				setTimeout(
					() =>
						this.setState({
							height: getScrollHeight(this.instance),
						}),
					0,
				);

				// clear
				setTimeout(
					() => this.setState({ height: null, overflow: null }),
					350,
				);
			},
		);
	}

	exit() {
		// initial
		this.setState(
			{ height: getScrollHeight(this.instance), overflow: 'hidden' },
			() => {
				// animate
				setTimeout(
					() => this.setState({ height: this.teaserHeight || 0 }),
					0,
				);

				// clear
				setTimeout(() => this.setState({ expanded: false }), 350);
			},
		);
	}

	bindRef(ref) {
		this.instance = ref;
		if (this.instance && this.props.showTeaser && !this.props.showing) {
			this.teaserHeight = getOffsetHeight(this.instance);
			this.setState({ height: this.teaserHeight });
		}
	}

	render() {
		const { children, showTeaser, preserve } = this.props;
		const { expanded, overflow, height } = this.state;
		return preserve || expanded || showTeaser
			? React.cloneElement(children, {
					ref: this.bindRef,
					style: {
						overflow,
						transition: 'height 250ms ease-out',
						height,
					},
					className: classnames(
						children.props.className,
						'expand-content',
						{
							collapsed: showTeaser && !expanded,
							expanded: showTeaser && expanded,
							'preserve-collapsed': preserve && !expanded,
						},
					),
				})
			: null;
	}
}

Expand.propTypes = {
	showing: PropTypes.bool,
	children: PropTypes.node,
	/** Shows the initial offset height of the child container instead of collapsing it */
	showTeaser: PropTypes.bool,
	preserve: PropTypes.bool,
};

Expand.defaultProps = {
	showTeaser: false,
	preserve: false,
};
